import {
  fetchStateFailed,
  fetchStateSuccess,
  fetchStateInvoked,
  STATE_FETCH_DATA,
  TOGGLE_MESSAGE_COLLAPSED_INVOKED,
  toggleMessageCollapsed,
} from "src/redux/actions/user";
import { put, call, takeLatest } from "redux-saga/effects";
import { getState } from "src/services/user";
import { toggleMessageCollapsedPref } from "src/services/messages";
import { UserMessageI } from "src/redux/reducers/user";
import { UserI } from "src/types/User";

function* fetchStateGen() {
  try {
    yield put(fetchStateInvoked());
    const payload: UserI = yield call(getState);
    yield put(fetchStateSuccess(payload));
  } catch (ex) {
    yield put(fetchStateFailed(ex));
  }
}

function* toggleMessage({
  userMessage,
}: {
  type: string;
  userMessage: UserMessageI;
}) {
  try {
    yield put(toggleMessageCollapsed(userMessage));
    yield call(toggleMessageCollapsedPref, {
      companyFeatureId: userMessage.companyFeatureId,
      isCollapsed: !userMessage.isOpen,
    });
  } catch (e) {
    console.error("toggle error");
  }
}

function* userSaga() {
  yield takeLatest(STATE_FETCH_DATA, fetchStateGen);
  yield takeLatest(TOGGLE_MESSAGE_COLLAPSED_INVOKED, toggleMessage);
}

export default userSaga;
